import React from 'react';
import {
  BankOutlined,
  FundOutlined,
  ReadOutlined,
  VideoCameraOutlined,
  PlaySquareOutlined,
  CodeOutlined,
  SolutionOutlined,
} from '@ant-design/icons';
import useReveal from '../../AIEmployees/useReveal';
import './SAFields.css';

/**
 * SAFields — "Built for the hardest work." Social-proof-by-breadth: CellCog's
 * users do genuinely complex work across an unusually wide range of fields.
 * The point isn't any single vertical — it's that the same agent handles all
 * of them at real complexity.
 */
const FIELDS = [
  { Icon: BankOutlined, label: 'Legal' },
  { Icon: FundOutlined, label: 'Finance' },
  { Icon: ReadOutlined, label: 'Storybooks' },
  { Icon: VideoCameraOutlined, label: 'Film & video' },
  { Icon: PlaySquareOutlined, label: 'Marketing video' },
  { Icon: CodeOutlined, label: 'Coding' },
  { Icon: SolutionOutlined, label: 'Customer outreach' },
];

const SAFields = () => {
  const [ref, visible] = useReveal();
  return (
    <section className="sa-fields aie-section">
      <div className="aie-section-head">
        <h2 className="aie-section-title aie-display">
          The hardest work, across the widest range of fields.
        </h2>
        <p className="aie-section-sub">
          CellCog&rsquo;s users aren&rsquo;t running toy prompts. They&rsquo;re
          doing genuinely complex work &mdash; and an unusually broad spread of it.
        </p>
      </div>
      <div className={`sa-fields__grid aie-reveal ${visible ? 'is-visible' : ''}`} ref={ref}>
        {FIELDS.map(({ Icon, label }) => (
          <div className="sa-fields__tile" key={label}>
            <span className="sa-fields__icon"><Icon /></span>
            <span className="sa-fields__label">{label}</span>
          </div>
        ))}
      </div>
      <p className="sa-fields__kicker">
        You name it, someone&rsquo;s doing it here &mdash; in earnest, at real
        complexity.
      </p>
    </section>
  );
};

export default SAFields;
